import React, { useEffect, useRef } from "react";

/**
 * GLOBAL SWITCH
 * Flip this to true after ad approval
 */
const ADS_ENABLED = true;

// Load AdSense script only once
let adsenseScriptLoaded = false;

const WaldoAd = ({ type, className = "" }) => {
  const adContainerRef = useRef(null);
  const adInitialized = useRef(false);

  // Load AdSense script only once
  useEffect(() => {
    if (!ADS_ENABLED) return;
    
    const loadAdSenseScript = () => {
      if (!adsenseScriptLoaded && !document.querySelector('script[src*="pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]')) {
        const script = document.createElement('script');
        script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5053752584555303';
        script.async = true;
        script.crossOrigin = 'anonymous';
        script.setAttribute('data-ad-client', 'ca-pub-5053752584555303');
        document.head.appendChild(script);
        adsenseScriptLoaded = true;
      }
    };

    loadAdSenseScript();
  }, []);

  // Push ad when component mounts and when DOM is ready
  useEffect(() => {
    if (!ADS_ENABLED) return;

    const pushAd = () => {
      // Check if container exists and ad hasn't been initialized
      if (!adContainerRef.current || adInitialized.current) return;

      try {
        // Ensure the ad container has the ins element
        const insElement = adContainerRef.current.querySelector('ins.adsbygoogle');
        if (!insElement) return;

        // Mark as initialized to prevent duplicate pushes
        adInitialized.current = true;

        // Small delay to ensure DOM is fully rendered
        setTimeout(() => {
          try {
            // Push the ad
            (window.adsbygoogle = window.adsbygoogle || []).push({});
          } catch (error) {
            // Ignore "No ads available" errors - these are normal
            if (!error.message || !error.message.includes('No ads')) {
              console.error('AdSense push error:', error);
            }
          }
        }, 100);
      } catch (error) {
        console.error('AdSense initialization error:', error);
      }
    };

    // Try to push ad immediately
    pushAd();

    // Also try after a delay (helps with React rendering)
    const timer = setTimeout(pushAd, 500);

    return () => clearTimeout(timer);
  }, [type]); // Re-run if type changes

  // Don't render anything when ads are disabled
  if (!ADS_ENABLED) {
    return null;
  }

  // Horizontal Ad
  if (type === "horizontal") {
    return (
      <div 
        ref={adContainerRef}
        className={`ad-container ad-horizontal ${className}`}
        style={{
          width: '100%',
          minHeight: '120px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: '20px 0',
          overflow: 'hidden'
        }}
      >
        <ins
          className="adsbygoogle"
          style={{
            display: 'block',
            width: '100%',
            height: '100%',
            minHeight: '120px'
          }}
          data-ad-client="ca-pub-5053752584555303"
          data-ad-slot="8566049712"
          data-ad-format="auto"
          data-full-width-responsive="true"
        />
      </div>
    );
  }

  // Square Ad
  if (type === "square") {
    return (
      <div 
        ref={adContainerRef}
        className={`ad-container ad-square ${className}`}
        style={{
          width: '100%',
          maxWidth: '300px',
          minHeight: '250px',
          margin: '20px auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden'
        }}
      >
        <ins
          className="adsbygoogle"
          style={{
            display: 'block',
            width: '100%',
            height: '100%',
            minHeight: '250px'
          }}
          data-ad-client="ca-pub-5053752584555303"
          data-ad-slot="8482191171"
          data-ad-format="auto"
          data-full-width-responsive="true"
        />
      </div>
    );
  }

  return null;
};

export default WaldoAd;